import { createClient } from '@supabase/supabase-js';

const supabaseUrl = (import.meta.env.VITE_PUBLIC_SUPABASE_URL as string) ?? '';
const supabaseAnonKey = (import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY as string) ?? '';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Direct edge function base — hardcoded as fallback
export const EDGE_BASE = supabaseUrl
  ? `${supabaseUrl}/functions/v1`
  : 'https://cgcknpucqclqhajvfjap.supabase.co/functions/v1';
